module.exports = __webpack_public_path__ + "static/media/maxSpeedIcon.1b746e58.png";